<template>
  <div class="lgpd-dialog">
    <v-dialog
      v-if="this.lgpd"
      v-model="this.lgpd"
      persistent
      width="95%"
    >
      <v-card class="pa-3 px-8">
          <v-row class="d-flex justify-center align-center">
            <v-col cols="12" md="10" class="px-2">
              O <strong>{{ sitename }}</strong> utiliza cookies e outras tecnologias semelhantes para melhorar a sua experiência em nossa plataforma. Ao continuar navegando, você concorda com as condições previstas na nossa <router-link to="/politica-de-privacidade">Política de Privacidade</router-link>.
            </v-col>
            <v-col cols="12" md="2">
              <v-btn
                class="btn-primary"
                large
                block
                @click="lgpd = false"
              >
                Concordo
              </v-btn>
            </v-col>
          </v-row>

        <!-- <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn
            color="primary"
            text
            @click="dialog = false"
          >
            I accept
          </v-btn>
        </v-card-actions> -->
      </v-card>
    </v-dialog>
  </div>
</template>

<script>
export default {
  name: 'LGPD',
  // props: {
  //   lgpd: Boolean
  // },
  data() {
    return {
      sitename: 'Centro Multidisciplinar Fluminense',
      lgpd: true
    }
  },
  methods: {

  }
}
</script>

<style lang="scss">
@import '@/variables/style.scss';

// .lgpd-dialog {
  .v-dialog--persistent {
    position: absolute !important;
    bottom: 0;
    // right: 0;
  }
// }

</style>